<template>
    <v-dialog
        v-model="displayDialog"
        width="500"
        :persistent="true"
    >
        <v-card light>
            <v-card-title
                class="headline"
                primary-title
            >
                <h2 class="dialog-notify-title">{{ titleAsData || title }}</h2>
            </v-card-title>
            <v-card-text>
                <slot name="content">
                    <div v-html="message"></div>
                </slot>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    @click="displayDialog = false"
                >
                    {{$t('partials.dialog_notify.close_btn')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    components: {},

    props: {

        title: {
            type: String,
            required: false,
            default: '',
        },
    },

    data() {
        return {
            displayDialog: false,
            message: null,
            titleAsData: null,
        };
    },

    computed: {
    },

    mounted() {},

    methods: {
        open (message=null, title=null){
            this.displayDialog = true;
            this.message = message;
            this.titleAsData = title;
        },
    },
};

</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Partials/dialog-notify.vue